const InnerPageHeader = (props) => {
    return (
        <div className="container-fluid inner-page-header">
            <h1>{props.title}</h1>
        </div>
    );
};
export default InnerPageHeader;
